<template>
  <div :class="$style.container">
    <div :class="[$style.buttonContainer, verticalAlign && $style.vertical]">
      <XButton
        v-for="(sso, index) in oauthSsoOptions"
        v-show="isVisibleButton(sso.name)"
        :key="index"
        full-width
        :design="buttonDesign"
        :class="$style.oauthButton"
        :data-testid="sso.dataTestid"
        @click.prevent="action(sso)"
      >
        <div :class="$style.buttonContent">
          <img
            v-if="sso.buttonImage"
            :src="sso.buttonImage"
            :class="$style.buttonImage"
          />
          <XIcon
            v-else-if="sso.buttonIcon"
            :icon="sso.buttonIcon"
          />
          {{ sso.buttonText }}
        </div>
      </XButton>
    </div>
  </div>
</template>

<script>
import { useGA } from '@base/hooks';
import microsoftImage from '@auth/assets/images/microsoft-symbol-logo.svg';
import googleImage from '@auth/assets/images/google-symbol-logo.svg';

export default {
  name: 'AuthSsoOptions',
  props: {
    oauthLinks: {
      type: Object,
      default: () => ({}),
    },
    visibleButtons: {
      type: Array,
      default: () => ['google', 'microsoft', 'saml'],
    },
    verticalAlign: {
      type: Boolean,
      default: false,
    },
    buttonDesign: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      oauthSsoOptions: [
        {
          name: 'google',
          link: this.oauthLinks.google,
          buttonImage: googleImage,
          buttonText: this.verticalAlign
            ? this.$t('auth.userSignup.oauth.withGoogle')
            : this.$t('auth.userSignup.oauth.google'),
          dataTestid: 'loginGoogleButton',
          gaEventLabel: 'button-google-sso-click',
        },
        {
          name: 'microsoft',
          link: this.oauthLinks.microsoft,
          buttonImage: microsoftImage,
          buttonText: this.verticalAlign
            ? this.$t('auth.userSignup.oauth.withMicrosoft')
            : this.$t('auth.userSignup.oauth.microsoft'),
          dataTestid: 'loginMicrosoftButton',
          gaEventLabel: 'button-microsoft-sso-click',
        },
        {
          name: 'saml',
          buttonIcon: 'key',
          buttonText: this.$t('auth.signin.oauth.saml'),
          dataTestid: 'loginSamlButton',
          gaEventLabel: 'button-enterprise-sso-click',
        },
      ],
    };
  },
  methods: {
    action(sso) {
      useGA('event', sso.gaEventLabel, 'signin-app');
      if (sso.name === 'saml') {
        this.$emit('login-saml');
      } else {
        this.$goTo(sso.link);
      }
    },
    isVisibleButton(buttonName) {
      return this.visibleButtons.includes(buttonName);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  .buttonContainer {
    display: flex;
    flex-direction: column;
    gap: var(--space-small-xx);

    &.vertical {
      @include breakpoint('medium') {
        flex-direction: column;
      }
    }

    @include breakpoint('medium') {
      flex-direction: row;
    }
  }

  .oauthButton {
    .buttonContent {
      display: flex;
      align-items: center;
      gap: var(--space-small-xx);
      white-space: nowrap;
    }

    .buttonImage {
      height: 16px;
    }
  }
}
</style>
